export const FORMSATTR = {
  templateName: {
    rules: { required: true, maxLength: 30, type: 'string' },
    value: '',
    status: [[{ id: 'required' }, {}]],
  },
  supplier_id: {
    rules: { minLength: true, maxLength: 100, type: 'string' },
    value: '',
    status: [[{ id: 'required' }, {}]],
  },
};

export const TABLEATTR = [
  'CIF',
  'docket_number',
  'plant',
  'arriving_date',
  'recipe',
  'delivered',
  'manufacture_time',
  'concrete_id',
  'compound',
  'relation_wc',
  'admixtures_id',
  'admixtures_quantity',
  'admixtures_extra',
  'delivery_company',
  'truck',
  'driver',
  'delivery_company_cif',
];
